import { render } from "./ServicesComponents.vue?vue&type=template&id=97825360"
import script from "./ServicesComponents.vue?vue&type=script&lang=js"
export * from "./ServicesComponents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dhaffaabdillah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__